import React from "react";
import Button from "../../../Components/commonButton/commonButton";
import Api from "../../../services/api";
import Alert from "../../../Components/alert/Alert";
import { SortByProperty, setCheckValue } from "../../../services/Functions";
import Select from "../../../Components/select/select";
import TimeTextField from "../../../Components/timeTextField/TimeTextField";
import "../general.css";
import TextField from "../../../Components/textField/textField";
import { ThemeConsumer } from "react-bootstrap/esm/ThemeProvider";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import { Checkbox } from "../../../Components/Checkbox/checkbox";
import { Col } from "react-bootstrap";
import { Checkboxcontainer } from "../../../Components/Checkboxcontainer/Chechboxcontainer";

export default class alter_reason extends React.Component {
  state = {
    reasons: [],
    reasonsId: [],
    description: "",
    id: 0,
    message: "",
    reload: false,
    show: false,
    code: null,
    reload: false,
    checked: false,
    ftq_count: false,
    andon: false,
    block_machine: false,
    planned_time: "",
    planned_stop: false,
    all_days: false,
    readOnly: true,
    notification: false,
    notification_type: "success",
    notification_message: "",
  };

  componentDidMount() {
    Api.get("/reasons-stop/").then((resp) => {
      let arr = [];
      resp.data.response.forEach((element) => {
        arr.push({
          value: element.id,
          label: element.code + "-" + element.description,
        });
      });
      this.setState({ reasons: arr });
      this.state.reasons.sort(SortByProperty("value"));
      this.setState({ reasonsId: [...resp.data.response] });
    });
  }

  stopTimeCallback = (value) => {
    this.setState({ planned_time: value });
  };

  setCheckValue = (data) => {
    const boolVal = /true/i.test(data.target.value);
    this.setState({ [data.target.name]: !boolVal });
    const forms = document.querySelectorAll("form");
    const form = forms[0];

    Array.from(form.elements).forEach((element) => {
      if (element.type === "checkbox" && element.name !== data.target.name) {
        if (!boolVal) element.disabled = true;
        else element.disabled = false;
      }
    });
  };

  SelectedReason = (childData) => {
    const result = this.state.reasonsId.find((v) => v.id == childData);
    this.setState(
      {
        id: result.id,
        description: result.description,
        code: result.code,
        andon: result.tracking,
        ftq_count: result.ftq_count,
        block_machine: result.block_machine,
        planned_stop: Boolean(Number(result.planned_stop)),
        planned_time: result.planned_time,
        all_days: result.all_days,
        readOnly: false,
      },
      () => {
        /* for (const key in result) {
        if (Object.hasOwnProperty.call(result, key)) {
          if(result[key] === 1 && key !== 'id' && key !=='code' && key !=='description'){
            return this.setCheckValueLocal(result[key],key)
          }
         
        }
      } */
      }
    );
  };

  sendData = async (id) => {
    if (
      id > 0 &&
      this.state.description !== null &&
      this.state.description !== "" &&
      this.state.code !== null &&
      this.state.code !== "" &&
      ((this.state.planned_stop == true &&
        this.state.planned_time != "00:00:00" &&
        this.state.planned_time != "" &&
        this.state.planned_time != null) ||
        this.state.planned_stop == false)
    ) {
      await Api.put(`/reasons-stop/${id}`, {
        code: this.state.code,
        description: this.state.description,
        tracking: this.state.andon,
        ftq_count: this.state.ftq_count,
        planned_stop: this.state.planned_stop,
        planned_time: this.state.planned_time,
        block_machine: this.state.block_machine,
        all_days: this.state.all_days,
        notification: false,
        notification_type: "success",
        notification_message: "",
      })
        .then((response) => {
          this.setState({
            notification: true,
            notification_message: "Motivo editado com sucesso!",
          });
          setTimeout(() => {
            return window.location.reload();
          }, 2000);
        })
        .catch((error) => {
          if (error.response) {
            this.setState({ message: "" + error.response.data, show: true });
          }
        });
    } else {
      this.setState({
        message: "Necessário preencher todos os campos.",
        show: true,
        reload: false,
      });
    }
  };

  changeValue = (value) => {
    this.setState({ description: value });
  };
  changeValueCode = (value) => {
    this.setState({ code: value });
  };
  callbackfunction = () => {
    this.setState({ show: false });
  };

  handleKeys = (e) => {
    if (document.getElementById("n1")) {
      let x = document.getElementById("n1");
      let vallen = x.value.length;
      if (
        (e.which != 8 && e.which != 46 && e.which != 0 && e.which < 48) ||
        e.which > 57 ||
        e.key == "."
      ) {
        e.preventDefault();
      }
    }
  };

  render() {
    const checkboxConfigs = [
      { key: "andon", label: "Andon" },
      { key: "ftq_count", label: "Setup/FTQ" },
      { key: "block_machine", label: "Bloquear Máquina" },
    ];

    let {
      show,
      message,
      reload,
      notification,
      notification_message,
      notification_type,
    } = this.state;
    return (
      <div className="box">
        {notification == true ? (
          <>
            <Notification
              message={notification_message}
              type={notification_type}
            ></Notification>
            <Loading></Loading>
          </>
        ) : (
          <></>
        )}
        <form className="input_fields_alt_reason form">
          <h4>Alterar Motivo</h4>
          {show ? (
            <Alert
              show={show}
              message={message}
              parentCallback={this.callbackfunction}
              reload={reload}
            />
          ) : null}
          <div className="inputs">
            <div className="selectAltReason element">
              <Select
                autoSelect={true}
                label="Selecionar motivo"
                arrData={this.state.reasons}
                handleSelect={this.SelectedReason}
              />
            </div>
            <div className="tf1AltReason element">
              <TextField
                className="input Entrada"
                title="Descrição"
                max={45}
                value={this.state.description}
                parentCallback={this.changeValue}
                validationType="varchar"
                readOnly={this.state.readOnly}
              />
            </div>
            <div className="tf2AltReason element">
              <TextField
                id="n1"
                title="Código"
                max={4}
                value={this.state.code}
                parentCallback={this.changeValueCode}
                validationType="int"
                readOnly={this.state.readOnly}
                className="input"
              />
            </div>
            <Checkboxcontainer label="Tipos de Parada" icon="info" size>
              {checkboxConfigs.map(({ key, label }) => (
                <Col xs="12" sm="6" className="pe-0">
                  {" "}
                  <Checkbox
                    key={key}
                    id={key}
                    label={label}
                    checked={this.state[key]}
                    setIsActive={() =>
                      this.setState({ [key]: !this.state[key] })
                    }
                     disabled={this.state.planned_stop}
                  />
                </Col>
              ))}
              <Col xs="12" sm={6}>
                {" "}
                <Checkbox
                  id="planned_stop"
                  label="Parada Programada"
                  checked={this.state.planned_stop}
                  setIsActive={() =>
                    this.setState(
                      { planned_stop: !this.state.planned_stop },
                      () => {
                        if (this.state.planned_stop) {
                          document.getElementById("time-texfield")?.focus();
                        }
                      }
                    )
                  }
                />
              </Col>
            </Checkboxcontainer>

            {this.state.planned_stop && (
              <div className="tf3AddReason element">
                <TimeTextField
                  id={"time-texfield"}
                  title="Tempo de parada"
                  hideInput={false}
                  parentCallback={this.stopTimeCallback}
                  value={this.state.planned_time}
                  seconds={true}
                  disabled={false}
                />
              </div>
            )}

            {this.state.planned_stop && (
              <div className="checkboxs">
                <Checkbox
                  id="all_days"
                  label="Ocorre em todos os dias, em todos os turnos."
                  checked={this.state.all_days}
                  setIsActive={() =>
                    this.setState({ all_days: !this.state.all_days })
                  }
                />
              </div>
            )}
          </div>
          <div className="btnAltReason submitButton">
            <Button
              icon="alt"
              title="Alterar"
              parentCallback={() => this.sendData(this.state.id)}
            />
          </div>
        </form>
      </div>
    );
  }
}
